// if animation-timeline not supported, do this instead

// in English:
// I need a create a function, which accepts
// found from https://gist.github.com/jjmu15/8646226
function isInViewport( element ) {
	const rect = element.getBoundingClientRect();
	const html = document.documentElement;
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= ( window.innerHeight || html.clientHeight ) &&
		rect.right <= ( window.innerWidth || html.clientWidth )
	);
}

window.addEventListener( 'load', function() {
	const headerCarouselPage = document.querySelector( '.header-carousel' );

	if ( ! headerCarouselPage ) {
		return;
	}

	if ( ! window.CSS ) {
		return;
		// CSS.Supports() not supported, so just bail - we don't support browsers who don't support CSS.Supports (try saying that afer a few beers) https://caniuse.com/?search=css.supports
	}

	const animationTimelineSupport = CSS.supports( 'animation-timeline', 'auto' ); // eslint-disable-line no-undef

	if ( animationTimelineSupport ) {
		// we have support, just use the CSS method which will come to all browsers soon
		return;
	}

	const headerCarouselProductCategoryLinkMenu = headerCarouselPage.querySelector( '.product-category-nav' );
	const productGridProductCategoryLinkMenu = document.querySelector( '.product-grid .product-category-nav' );

	// hide second header by default
	productGridProductCategoryLinkMenu.classList.add( 'product-category-nav--hide' );

	// so now change the product menu category classes on scroll:
	window.onscroll = function() {
		if ( isInViewport( headerCarouselProductCategoryLinkMenu ) ) {
			// header menu
			headerCarouselProductCategoryLinkMenu.classList.add( 'product-category-nav--show' );
			headerCarouselProductCategoryLinkMenu.classList.remove( 'product-category-nav--hide' );

			// grid menu
			productGridProductCategoryLinkMenu.classList.add( 'product-category-nav--hide' );
			productGridProductCategoryLinkMenu.classList.remove( 'product-category-nav--show' );
		} else {
			// header menu
			headerCarouselProductCategoryLinkMenu.classList.remove( 'product-category-nav--show' );
			headerCarouselProductCategoryLinkMenu.classList.add( 'product-category-nav--hide' );

			// grid menu
			productGridProductCategoryLinkMenu.classList.remove( 'product-category-nav--hide' );
			productGridProductCategoryLinkMenu.classList.add( 'product-category-nav--show' );
		}
	};
} );
